// API
export const PRO_CONFIG = {
	serviceName: '我的模块',
	serviceId: 'ZFT_MYMODULE',
	app_id: '196236727', // 防水墙ID,后台提供
	Vconsole: false,
	Comapi: 'https://api.fcsc.com/baseservice', // 生产环境
	safetyApi: 'https://api.fcsc.com/myModuleService', // 安全中心开发环境
	Homeapi: 'https://api.fcsc.com/myModuleService/', // 生产环境
	Imgapi: 'https://con.fcsc.com/fileapi/fileapi/displayImage/', // 生产环境
	getOFid: 'https://api.fcsc.com/strategyservice/other/protected/queryOfId?crmId=', // 查询ofid生产环境
	imgUpload: 'https://api.fcsc.com/zuul/fastdfsclient/public/outerupload', // 图片上传（生产环境）
	deleteImg: 'https://api.fcsc.com/zuul/fastdfsclient/public/outerdelete', // 图片删除（生产环境）
	Buriedapi: 'https://api.fcsc.com/baseservice/protected/evidence/save', // 埋点API
	bmdapi: 'https://impush.fcsc.com/servlet/json?funcNo=5000011&appkey=ZJBroker&checkId=', // 在线交流白名单
	ytgimg: 'https://ytg.fcsc.com', // 云投顾头像
	ywblurl: 'https://ob.95358.com', // 业务办理跳转链接
	aefjx: 'https://ytg.fcsc.com/m/ycytg/index.html#!/portfolio/detail.html?=&portfolio_id=300133&orderType=35', // 阿尔法精选
	URL_JFSC: 'https://ad.fcsc.com', // 积分商城服务
    URL_JFSC_WEB: 'https://ad.fcsc.com/echuang_fnt', // 积分商城网页
	NEW_JFSC: 'https://ad.fcsc.com/yichuang_mall_fnt/wx/oauth2_checking.php?', // 新积分商城
	Bindapi: 'https://api.fcsc.com/unifiedAccountService', // 用户绑定
    URL_FXHY: 'https://digitinfo.95358.com/api/v1/invitationweb#/?activityNo=978293', // 邀请好友
    tznc: 'https://digit.95358.com/api/v1/finminiprogramh5/index.html#/pages/square/index', // 投资内参
    URL_COUPON: 'https://api.fcsc.com/paymentService', // 优惠券
    URL_COUPON_IMG: ' https://digit.95358.com/api/v1', // 优惠券背景图片
   	URL_LEVEL_WEB: 'https://digitinfo.95358.com/api/v1/activity-zone-web/#/coupons?type=1&gameId=100', // 兑换码跳转
	WXTX_URL: 'https://digit.95358.com', // 微信提醒
	clientId: 'zIxkpcyNZJhmnp27FIQViNsYQTVfAVVg',
	wxxyID: {one: '191', two: '192'}, // 微信协议ID
	xhxyID: '231', // 销户协议ID
	aplus: 'track.fcsc.com', // 阿里云埋点配置
	appKey: 'qvaqia7l0kugce8ktzwq1e8t', // 阿里云埋点配置
	NEWSURL: 'https://news.fcsc.com', // 在线客服地址
	businesscode: {clgj: '1141', level: '1005', etg1: '1101', etg2: '1102'},
	API_URL: 'https://api.fcsc.com',
	digitinfo: 'https://digitinfo.95358.com',
	strategy: 'https://tradestrategy.95358.com:8000/h5',
	ytgApi: 'https://ytg.95358.com',
	cloudapi: 'https://lcs.fcsc.com',
	originId: 'gh_45b4cd1b0b9b',
	aeskey: '9wQHCmNlHqKtrz8PxcKrNVwm',
	vikey: 'ozcs3RRS9NLCLj0v'
}


// WEBPACK FOOTER //
// ./src/api/config_master.js